var _defs, _g, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLockUnlocked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46 46.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4{fill:none;}.cls-1,.cls-2,.cls-3{stroke:#000;stroke-width:4px;}.cls-1,.cls-2{stroke-miterlimit:10;}.cls-2{fill-rule:evenodd;}.cls-3{stroke-linecap:round;stroke-linejoin:round;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Unlocked_46") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Unlock_icon",
    "data-name": "Unlock icon"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 8.63,
    y: 18.25,
    width: 28.74,
    height: 25.86,
    rx: 6.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.19,10.12V3.7c0-.94-1.55-1.7-3.47-1.7H18.81c-1.92,0-3.48.76-3.48,1.7V18.25"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 23,
    y1: 27.9,
    x2: 23,
    y2: 34.45
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    y: 0.05,
    width: 46,
    height: 46
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLockUnlocked);
export default __webpack_public_path__ + "static/media/icon_lock_unlocked.ed673f55208f9999dd3a022df34632b7.svg";
export { ForwardRef as ReactComponent };